<template>
  <!--医学动态TAB切换模块-->
  <div class="nc_dynamic">
    <div class="nc_title">
      <p class="nc_title_L">医学动态</p>
      <p class="nc_title_S"><span>成都中医药大学 — 为您提供最新动态</span></p>
    </div>
    <div class="ncd_title">
      <ul>
        <li :class="{ ncdt_sel: customNewsTag===6 }" @click="switchCustomNews(6)"><a href="javascript:;">前沿动态</a></li>
        <li :class="{ ncdt_sel: customNewsTag===7 }" @click="switchCustomNews(7)"><a href="javascript:;">医事经纬</a></li>
        <li :class="{ ncdt_sel: customNewsTag===8 }" @click="switchCustomNews(8)"><a href="javascript:;">病例讨论</a></li>
        <li :class="{ ncdt_sel: customNewsTag===9 }" @click="switchCustomNews(9)"><a href="javascript:;">行业信息</a></li>
        <li :class="{ ncdt_sel: customNewsTag===12 }" @click="switchCustomNews(12)"><a href="javascript:;">学术会议</a></li>
      </ul>
    </div>
    <div class="ncd_main" v-loading="loading">
      <div class="ncdm_left f_l">
        <div class="ncdml"v-for="(item,index) in customNews" v-if="index===0">
          <div class="ncdml_pic"><router-link :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank"><img  :src="item.image" width="120" height="90"></router-link></div>
          <div class="ncdml_main">
            <p class="ncdml_main_title textover"><router-link :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank">{{item.newsTitle}}</router-link></p>
            <p class="ncdml_main_text"><a href="javascript:;">{{item.description.length>450?item.description.substring(0,450) + '...':item.description}}</a></p>
            <p class="ncdml_main_detail"><router-link :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank">[阅读详细]</router-link></p>
          </div>
        </div>
      </div>
      <div class="ncdm_right f_r">
        <ul>
          <li v-for="(item,index) in customNews" :key="item.id" v-if="index>0"><router-link :to="{ path: '/newsInfo', query: { id: item.id }}" target="_blank">{{item.newsTitle}}
          </router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD')}}</span></li>
        </ul>
        <!--<div class="ncdm_right_more"><router-link :to="{ path: '/newsMore'}" >查看更多</router-link></div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import {listNews} from '../api/api';
  export default {
    components: {},
    props: {
      projectIdsC: {
        type: Array,
        default: function () {
          return []
        }
      },
      parentTagId:{
        type: String,
        default: function () {
          return ''
        }
      },
      tagId:{
        type: String,
        default: function () {
          return ''
        }
      }

    },
    data () {
      return {
        loading: false,
        customNews: null,
        customNewsTag: 6
      }
    },
    mounted () {
      this.switchCustomNews(this.customNewsTag)
    },
    computed: {},
    methods: {
      switchCustomNews(consultId){
        this.loading=true;
        this.customNewsTag = consultId
        listNews({
          consultId: consultId,
          parentTagId:this.parentTagId,
          tagId:this.tagId,
          publishState: 0,
          publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
          'displayPositionIds': [1, 3],
          'notProjectIds': [8, 9],
          'projectIdsC': this.projectIdsC,
          'orderWeight': true,
          orderPublishTime: true,
          pageNum: 1,
          pageSize: 7
        }).then((response) => {
          this.customNews = response.data.data.list;
          this.loading=false;
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MedicalDynamicNews.vue